import { render, staticRenderFns } from "./shipping-price-table.vue?vue&type=template&id=6e8af1a8&scoped=true&"
import script from "./shipping-price-table.vue?vue&type=script&lang=js&"
export * from "./shipping-price-table.vue?vue&type=script&lang=js&"
import style0 from "./shipping-price-table.vue?vue&type=style&index=0&id=6e8af1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8af1a8",
  null
  
)

export default component.exports